import { render, staticRenderFns } from "./BaseButtonRender.vue?vue&type=template&id=4979ba03&"
import script from "./BaseButtonRender.vue?vue&type=script&lang=ts&"
export * from "./BaseButtonRender.vue?vue&type=script&lang=ts&"
import style0 from "./BaseButtonRender.vue?vue&type=style&index=0&id=4979ba03&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports